import en from './en.json';
import de from './de.json';
import fr from './fr.json';
import nl from './nl.json';
import it from './it.json';
import es from './es.json';
import pt from './pt.json';
import is from './is.json';
import da from './da.json';
import no from './no.json';
import sv from './sv.json';
import fi from './fi.json';
import hu from './hu.json';
import pl from './pl.json';
import cs from './cs.json';
import sk from './sk.json';
import sl from './sl.json';
import hr from './hr.json';
import ro from './ro.json';
import lt from './lt.json';
import lv from './lv.json';
import et from './et.json';
import id from './id.json';
import ja from './ja.json';
import zh from './zh.json';
import ko from './ko.json';
export default Object.fromEntries(Object.entries(en).map(([k,v])=>{
  return [k,{
    en:v,
    de:de[k],
    fr:fr[k],
    nl:nl[k],
    it:it[k],
    es:es[k],
    pt:pt[k],
    is:is[k],
    da:da[k],
    no:no[k],
    sv:sv[k],
    fi:fi[k],
    hu:hu[k],
    pl:pl[k],
    cs:cs[k],
    sk:sk[k],
    sl:sl[k],
    hr:hr[k],
    ro:ro[k],
    lt:lt[k],
    lv:lv[k],
    et:et[k],
    id:id[k],
    ja:ja[k],
    zh:zh[k],
    ko:ko[k],
  }];
}));

